export default __webpack_public_path__ + "static/fahrzeug-vivawest-6af703cdc48b7c8b7fed626157861181.jpg";